<template>
  <div class="head">
    <h1 class="title">官网编辑-XX科技有限责任公司</h1>

    <div>
      <button class="save_button" @click="$emit('save')">发布</button>
      <button class="save_button" @click="$emit('confirm')">保存</button>
      <button class="save_button" @click="$emit('save')">预览</button>
      <button class="save_button" @click="handlemo">模板</button>
    </div>
    <!-- 模板 -->
    <el-dialog title="小程序模板" :visible.sync="dialogVisible" width="30%">
      <div style="height: 100%;">
        <div style="text-align: center;">
          <el-input style="width: 350px;" placeholder="请输入内容" v-model="searchValue" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </div>
        <div class="template_list">
          <div class="template_item" v-for="item in templateList" :key="item.id">
            <div class="template_item_content">
              <div class="content-img" :style="{ backgroundImage: `url(${item.src})` }">
                <!-- <img :src="item.src" alt=""> -->

                <div class="template_item_use">
                  <div class="template_item_use_content">
                    <div class="template_item_use_content_item">
                      <img src="../assets/image-upload.jpg" alt="">
                      <span style="padding-bottom: 8px;">扫码预览</span>
                    </div>
                    <el-button style="margin-top: 17px;" type="primary" round size="small">使用模板</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="template_item_name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="white-space: nowrap;">共【22】条记录</div>
          <div>
            <el-pagination background small layout="prev, pager, next" :total="1000">
            </el-pagination>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xcmb from '@/assets/wxmb.jpg'
import api from '../api/index'
export default {
  name: 'Header',
  data () {
    return {
      dialogVisible: false,
      searchValue: '',
      pagerCount: 3,
      templateList: [
        {
          id: 1,
          name: '模板1',
          src: xcmb
        },
        {
          id: 2,
          name: '模板2',
          src: xcmb
        },
        {
          id: 3,
          name: '模板3',
          src: xcmb
        },
        {
          id: 4,
          name: '模板4',
          src: xcmb
        },
        {
          id: 5,
          name: '模板5',
          src: xcmb
        },
        {
          id: 6,
          name: '模板6',
          src: xcmb
        },
        {
          id: 7,
          name: '模板7',
          src: xcmb
        },
        {
          id: 8,
          name: '模板8',
          src: xcmb
        }
      ]
    }
  },
  methods: {
    async handlemo () {
      try {
        // eslint-disable-next-line standard/object-curly-even-spacing
        const data = { page: 1, title: this.searchValue}
        const response = await api.post('/applet/get_muban', data)
        console.log('请求模板数据:', response)
        if (response.code === 0) {

        }
      } catch (error) {
        console.error('Error sending data:', error)
      }
      this.dialogVisible = true
    },
    handleSearch () {
      this.handlemo()
    }
  }
}
</script>

<style scoped>
.head {
  background-color: #324057;
  height: 60px;
}

.title {
  font-size: 22px;
  height: 60px;
  line-height: 60px;
  color: #fff;
  margin: 0;
  padding-left: 2em;
  float: left;
  font-weight: normal;
}

.save_button {
  display: block;
  float: right;
  font-size: 16px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
  background: transparent;
  width: 130px;
  height: 32px;
  margin-top: 15px;
  margin-right: 24px;
  cursor: pointer;
}

button:hover {
  color: #58b7ff;
  border: 1px solid #58b7ff;
  background-color: #ffffff;
}

/deep/ .el-dialog {
  width: 1040px;
  min-width: 1040px;
  height: 80%;
  border-radius: 20px;
  overflow: hidden;
}

/deep/ .el-dialog__header {
  padding: 0;
  line-height: 54px;
  padding-left: 20px;
  font-weight: bold;
  background-color: #324057;
}

/deep/ .el-dialog__body {
  height: calc(100% - 110px);
}

/deep/ .el-dialog__title {
  color: #fff;
}

.template_list {
  height: calc(100% - 40px);
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-top: 20px
}

.template_item {
  /* width: 18.2%; */
  /* height: 382px; */
}

.template_item:hover .template_item_content {
  border-color: #007bfc;
}

.template_item_content {
  width: 100%;
  padding: 6px;
  position: relative;
  height: 333px;
  border: 1px solid #ebebeb;
  transition: 0.3s ease;
  background-color: #fff;
  border-radius: 20px;
}

.content-img {
  position: relative;
  height: 100%;
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% auto;
  border-radius: 20px;
}

.template_item_use {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.3);
}

.template_item_use_content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.template_item_use_content_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 6px;
}

.template_item_use_content_item img {
  width: 110px;
  height: 110px;
  margin: 9px;
}

.template_item:hover .template_item_use {
  display: block;
}

.template_item_name {
  font-size: 14px;
  color: #8992a1;
  line-height: 50px;
  text-align: center;
  font-weight: 400;
  margin: 0;
  padding: 0 0.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue